export default {"src":"/_next/static/media/ZeroBounce.9cc9adbd.svg","height":45,"width":157};